import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { DedicatedPlansState } from './types'
import { IHMSDedicatedServer } from '@/types/dedicated.interface'

const initialState: DedicatedPlansState = {
  list: [],
}

const dedicatedPlansSlice = createSlice({
  name: 'dedicated-plans',
  initialState,
  reducers: {
    setDedicatedPlans: (state, action: PayloadAction<IHMSDedicatedServer[]>) => {
      state.list = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        // @ts-ignore
        ...action.payload.dedicatedPlans,
      }
    })
  },
})

export const { setDedicatedPlans } = dedicatedPlansSlice.actions

export default dedicatedPlansSlice
